import { lazy } from 'react';

import { Navigate, Outlet, type RouteObject } from 'react-router-dom';

import NotFoundPage from '@/pages/NotFoundPage';

import { RecordingLayout } from '@/widgets/layouts';

import { RecordingMobileLockModalMount } from '@/features/recording/platformLock';
import { RecordingFeedbackBonusModal } from '@/features/recordingFeedbackBonus';
import { RecordingShareModal } from '@/features/recordingShare';
import { RecordingWelcomeSurveyMount } from '@/features/user/recordingWelcomeSurvey';

import { peekPendingRecordingRedirect } from '@/entities/recording';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';

const RecordingHomePage = lazy(() => import('@/pages/RecordingHomePage'));
const RecordingPage = lazy(() => import('@/pages/RecordingPage'));
const RecordingAccountPage = lazy(() => import('@/pages/RecordingAccountPage'));

const RecordingHomeEntry = () => {
  const pendingRecordId = peekPendingRecordingRedirect();

  if (pendingRecordId) {
    return <Navigate to={PATHS.recordingDetailLink(pendingRecordId)} replace />;
  }

  return <RecordingHomePage />;
};

const RecordingPostAuthShell = () => (
  <RecordingLayout>
    <Outlet />
    <RecordingWelcomeSurveyMount />
  </RecordingLayout>
);

const RecordingModalShell = () => (
  <>
    <Outlet />
    <RecordingFeedbackBonusModal />
    <RecordingShareModal />
  </>
);

const RecordingMobileGuard = () => (
  <>
    <RecordingMobileLockModalMount />
    <Outlet />
  </>
);

export const recordingAuthRoutes: RouteObject[] = [
  {
    children: [
      {
        children: [
          {
            children: [{ element: <RecordingHomeEntry />, index: true }],
            element: <RecordingPostAuthShell />,
          },
          { element: <RecordingPage />, path: PATHS.recordingDetail },
          ...(IS_WHITE_LABEL ? [] : [{ element: <RecordingAccountPage />, path: PATHS.account }]),
          { element: <NotFoundPage />, path: '*' },
        ],
        element: <RecordingModalShell />,
      },
    ],
    element: <RecordingMobileGuard />,
  },
];
